import { render } from "./SliderShowComponent.vue?vue&type=template&id=57a1c362"
import script from "./SliderShowComponent.vue?vue&type=script&lang=js"
export * from "./SliderShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Slider/SliderShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57a1c362"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57a1c362', __exports__)) {
    api.reload('57a1c362', __exports__)
  }
  
  module.hot.accept("./SliderShowComponent.vue?vue&type=template&id=57a1c362", () => {
    api.rerender('57a1c362', render)
  })

}


export default __exports__